import React, { useState } from 'react'
import './json-view.scss'
import classnames from 'classnames'
import { CodeFilled, CodeOutlined, CopyOutlined } from '@ant-design/icons'
import { Popover, Tooltip } from 'antd'
import JSONPretty from 'react-json-pretty'
import CopyToClipboard from 'react-copy-to-clipboard'
import { simpleNotification } from '@pushly/aqe/lib/utils'

const handleCopied = () => {
    simpleNotification('success', 'Copied', undefined, undefined, true)
}

interface IJsonViewProps {
    data: any
    replacer?: any
    hideActions?: boolean
    defaultExpanded?: boolean
}

const JsonView = ({ data, replacer, defaultExpanded, hideActions }: IJsonViewProps) => {
    const [expanded, setExpanded] = useState(defaultExpanded)
    const jsonStr = JSON.stringify(data, replacer)

    return (
        <div
            className={classnames('json-view', {
                expanded,
            })}
        >
            {!hideActions && [
                <div key="copy" className="copy">
                    <Tooltip title="Copy">
                        <CopyToClipboard onCopy={handleCopied} text={JSON.stringify(data)}>
                            <CopyOutlined />
                        </CopyToClipboard>
                    </Tooltip>
                </div>,
                <div key="toggle" className="toggle">
                    <Tooltip title={expanded ? 'Collapse' : 'Expand'}>
                        <span
                            onClick={() => {
                                setExpanded(!expanded)
                            }}
                        >
                            {!expanded ? <CodeFilled /> : <CodeOutlined />}
                        </span>
                    </Tooltip>
                </div>,
            ]}
            <div className="json-string">
                {!expanded ? (
                    <span>{jsonStr}</span>
                ) : (
                    <pre className="json-view-pretty">
                        <JSONPretty json={jsonStr} />
                    </pre>
                )}
            </div>
        </div>
    )
}

export default JsonView
